<template>
  <b-modal
    id="modal-confirm-broadcast"
    hide-footer
    hide-header
    centered
  >
    <div class="p-1">
      <div class="d-block text-center">
        <b-img
          center
          width="100"
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        />
        <div class="text-[24px] mt-1 font-semibold text-[#333333]">
          {{ titleText }}
        </div>
        <div class="text-[16px] mt-1 font-normal">
          <span v-html="descriptionText" />
        </div>
      </div>
      <div class="flex gap-2 mt-3 items-center">
        <b-button
          variant="outline-primary"
          block
          @click="$bvModal.hide('modal-confirm-broadcast')"
        >
          {{ labelCancelButton }}
        </b-button>
        <b-button
          variant="primary"
          block
          class="!mt-0"
          @click="$emit('onHandleConfirmBroadcast'); $bvModal.hide('modal-confirm-broadcast')"
        >
          {{ actionText }}
        </b-button>

      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  computed: {
    labelCancelButton() {
      return this.action === 'cancel' ? 'Tutup' : 'Batal'
    },
    actionText() {
      return this.action === 'cancel' ? 'Ya, Batalkan Broadcast' : 'Hapus'
    },
    titleText() {
      return this.action === 'cancel' ? 'Batalkan Broadcast' : 'Hapus Broadcast'
    },
    descriptionText() {
      return this.action === 'cancel' ? 'Kamu akan membatalkan <b>Proses Broadcast</b>, dengan membatalkan maka proses pengiriman pesan akan berhenti. Apakah kamu yakin?' : 'Kamu akan menghapus data. Apakah kamu yakin?'
    },
  },
}
</script>
